import { useEffect, useState } from 'react'
import { Overlay, Dialog, Header, Body, Intro, List, Item, Footer } from '../styles/RejectConfirmationModalStyle'
import { Icon } from '@iconify/react'

interface RejectModalProps {
  open: boolean
  txnId: string
  onClose: () => void
  onSubmit: (reason: string) => void
}


const reasons = [
  'Card code already used',
  'Card image not clear / unreadable',
  'Wrong gift card type selected',
  'Card value does not match the declared amount',
  'Screenshot or image is incomplete',
  'Multiple submissions of the same card',
  'Other issues'
]

export const RejectConfirmationModal = ({ open, txnId, onClose, onSubmit }: RejectModalProps) => {
  const [value, setValue] = useState('')
  const [customReason, setCustomReason] = useState('')

  useEffect(() => {
    if (open) {
      setValue('')
      setCustomReason('')
    }
    function esc(e:KeyboardEvent){ if(e.key==='Escape') onClose() }
    if(open) window.addEventListener('keydown', esc)
    return () => window.removeEventListener('keydown', esc)
  }, [open, onClose])

  if(!open) return null

  return (
    <Overlay onClick={onClose}>
      <Dialog role='dialog' aria-modal='true' aria-labelledby='reject-title' onClick={e=>e.stopPropagation()}>
        <Header>
          <h2 id='reject-title'>Reject gift card sale</h2>
          <button aria-label='Close' onClick={onClose}><Icon icon='material-symbols:close' width={20} /></button>
        </Header>
        <Body>
          <Intro>Please select the reason for rejecting <span style={{color:'#101018', fontFamily:'ui-monospace, SF Mono, monospace'}}>{txnId}</span> gift card sale. The user will be notified with your response.</Intro>
          <List>
            {reasons.map(r => (
              <Item key={r} selected={value===r}>
                <span>{r}</span>
                <span className='bullet'>
                  <input type='radio' name='reject_reason' value={r} onChange={()=>setValue(r)} checked={value===r} />
                </span>
              </Item>
            ))}
          </List>
          {value === 'Other issues' && (
            <textarea
              value={customReason}
              onChange={(e) => setCustomReason(e.target.value)}
              placeholder="Please specify the reason..."
              className="w-full mt-3 p-3 border border-[#E2E2E4] rounded-lg text-sm resize-none focus:outline-none focus:border-[#C02236]"
              rows={3}
            />
          )}
        </Body>
        <Footer>
          <button className='cancel' onClick={onClose}>Cancel</button>
          <button className='reject' disabled={!value || (value === 'Other issues' && !customReason.trim())} onClick={()=>{ if(value){ onSubmit(value === 'Other issues' ? customReason : value); onClose(); } }}>Reject</button>
        </Footer>
      </Dialog>
    </Overlay>
  )
}
